import React from 'react'

import { CellsWithSpacer } from './CellsWithSpacer'

interface RowProps extends Omit<React.HTMLAttributes<HTMLTableRowElement>, 'className'> {
  children: React.ReactNode;
  header: React.ReactNode;
}

export function Row ({ children, header, ...props }: RowProps) {
  return (
    <tr {...props} className='group/row'>
      <th
        className='text-left p-4 w-36 border-r border-b group-last/row:border-b-0 border-gray-200 font-normal text-gray-500 bg-white sticky left-0'
        scope='row'
      >
        {header}
      </th>
      <CellsWithSpacer>
        {children}
      </CellsWithSpacer>
    </tr>
  )
}

Row.displayName = 'PlanTable.Row'
